<template>
  <div class="wrapper" ref="wrapper">
    <div class="container-sm py-8 text-center relative transform-none">
      <form
        class="input-wrapper bg-white"
        @submit.prevent="handleCTA">
        <div class="free-text-search">
          <free-text-search
            ref="fts"
            v-model="entry.title"
            @confirmed="handleDestinationConfirmed"
            :search-type="searchType" />
        </div>

        <div class="product-display">
          <product-finder
            ref="productFinder"
            v-model="searchType" />
        </div>

        <div class="date-display">
          <date-picker v-model="dates" :search-type="searchType" />
        </div>

        <div class="guest-display">
          <guest-picker v-model="guests" :search-type="searchType" />
        </div>

        <div class="relative">
          <button type="submit" class="search-cta flex items-center">
            <svg width="24" height="24" class="fill-current mr-2">
              <use xlink:href="/img/sprite.svg#ic_search-solid"></use>
            </svg>
            Search
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import GuestPicker from '../Search/2021/GuestPicker'
import FreeTextSearch from '../Search/2021/FreeTextSearch'
import DatePicker from '../Search/2021/DatePicker'
import WidgetMixin from '../Search/2021/WidgetMixin'
import ProductFinder from '../Search/2021/ProductFinder'

export default {
  mixins: [WidgetMixin],
  components: {
    FreeTextSearch,
    GuestPicker,
    DatePicker,
    ProductFinder
  },
  data () {
    const searchParams = new URLSearchParams(window.location.search)
    let dates = []
    let guests = '0'

    if (searchParams.has('from')) {
      const from = moment(searchParams.get('from'), 'YYYY-MM-DD', true)
      const to = moment(searchParams.get('to'), 'YYYY-MM-DD', true)

      if (from.isValid()) {
        dates.push(from)
      }
      if (to.isValid()) {
        dates.push(to)
      }
    }

    if (searchParams.has('guests')) {
      guests = searchParams.get('guests')
    }

    return {
      entry: {
        title: window.zubluDestination ? window.zubluDestination.name : ''
      },
      dates,
      guests,
      isWorking: false,
      searchType: window.zubluSearchType || 'resort'
    }
  },
  mounted () {
    if (window.zubluDestination) {
      this.$refs.productFinder.fetchProductAvailability(window.zubluDestination.id);
    } else if (this.searchType === 'ecoventure') {
      const searchParams = new URLSearchParams(window.location.search)
      const destinationIds = searchParams.get('destinations') || ''
      const firstDestination = destinationIds.split(',')[0]

      if (firstDestination) {
        $.ajax({
          method: 'POST',
          url: '/',
          data: {
            destination_id: firstDestination,
            action: 'zuBlu/public/getDestinationStructureByCode',
            [window.Craft.csrfTokenName]: window.Craft.csrfTokenValue,
          },
          headers: {'Content-Type': 'application/x-www-form-urlencoded'}
        })
        .then(response => {
          try {
            this.entry.title = JSON.parse(response).name
            this.$refs.productFinder.fetchProductAvailability(JSON.parse(response).id);
          } catch (error) {}
        })
      }
    }

    const wrapper = this.$refs.wrapper
    const observer = new IntersectionObserver(([e]) => {
      e.target.classList.toggle('shadow', e.intersectionRatio < 1)
    }, { threshold: [1] })
    observer.observe(wrapper)
  },
  methods: {
    handleDestinationConfirmed (which) {
      this.handleConfirmed(which);
      this.$refs.productFinder.fetchProductAvailability(which.id);
    }
  }
}
</script>

<style scoped lang="scss">
::v-deep #main {
  position: relative;
}

.wrapper ::v-deep {
  position: sticky;
  top: -1px; // this using to triggle the IntersectionObserver
  left: 0;
  background-color: #F6F6F6;
  z-index: 10;

  .search-input {
    background: none;
    border: none;
    background-color: transparent;
  }
}

.free-text-search ::v-deep {
  .drop-panel:not(.featured-searches) {
    min-width: 275px;
    left: 114px;
    top: calc(100% - 20px);
    margin-top: 0;

    ul li {
      padding-left: 25px;
    }
  }

  .featured-searches {
    top: calc(100% - 22px);
  }
}

.product-display ::v-deep {
  .tooltip-content-wrapper ul {
    top: calc(100% + 12px);
    right: 0;
    left: 0;
    padding: 16px 0;

    li {
      align-items: center;
      padding: 10px 16px;

      & + li {
        margin-top: 12px;
      }

      &:hover {
        background: var(--black-light-1);
      }

      .icon {
        margin-right: 12px;
      }

      .text div {
        font-size: 1rem;
      }

      .text span {
        display: none;
      }
    }
  }
}

.date-display ::v-deep ,
.guest-display ::v-deep {
  .drop-panel {
    top: calc(100% + 12px);
  }
}

.input-wrapper {
  display: grid;
  grid-template-columns: auto 200px 200px 195px 90px;
  margin: auto 108px;
  padding: 0 1.5rem 0 0.5rem;
  box-shadow: inset 0 0 0 1px #e5e5e5;
  border-radius: 30px;
}

.input-wrapper ::v-deep .search-input {
  background: transparent;
  height: 48px;
  border: none;
}

.date-display,
.guest-display,
.product-display {
  position: relative;
}

.date-display::before,
.guest-display::before,
.product-display::before {
  content: '';
  position: absolute;
  top: 10px;
  bottom: 10px;
  left: -1px;
  width: 1px;
  background: #e5e5e5;
}

.search-cta {
  color: var(--secondary);
  border: 1px solid;
  border-radius: 30px;
  height: 48px;
  position: absolute;
  background: white;
  padding: 0 20px;
  right: -24px;
  white-space: nowrap;
  transition: ease .25s;

  &:hover {
    background: var(--cyan-light-1);
  }
}
.transform-none{
  transform: none !important;
}
</style>
